import styled from "styled-components"
import { 
    // COLOR,
    // FONT
 } from 'assets'
 
export const WheelsCreatorContainerStyled = styled.div`
/*===============================================
 Container 
===============================================*/
    
/*===============================================
Theme 
===============================================*/
  
`